export function startMailingListTimes(root = document) {
  root.querySelectorAll("time[data-browser-time]").forEach((element) => {
    const date = new Date(element.dateTime);
    if (!Number.isFinite(date.getTime())) return;

    element.textContent = new Intl.DateTimeFormat(undefined, {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "numeric",
      minute: "2-digit",
      timeZoneName: "short",
    }).format(date);
  });
}
